export interface AvatarAppearance {
  avatarUrl: string;
  lookTextureUrl?: string | null;
  animUrls?: Record<string, string> | null;
}

/** Omitted fields support old clients; explicit null removes a selection. */
export function mergeAvatarAppearance(previous: AvatarAppearance | undefined, incoming: Partial<AvatarAppearance>): AvatarAppearance {
  const avatarUrl = incoming.avatarUrl ?? previous?.avatarUrl ?? '';
  const sameModel = avatarUrl === previous?.avatarUrl;
  const lookTextureUrl = incoming.lookTextureUrl === undefined
    ? (sameModel ? previous?.lookTextureUrl ?? null : null) : incoming.lookTextureUrl;
  const clips = incoming.animUrls === undefined
    ? (sameModel ? previous?.animUrls ?? null : null) : incoming.animUrls;
  // Keep references stable so ordinary heartbeats don't rebuild mixers.
  const animUrls = JSON.stringify(clips) === JSON.stringify(previous?.animUrls) ? previous?.animUrls : clips;
  return { avatarUrl, lookTextureUrl, animUrls };
}
